import { defaultSliderLabelConfig, foundationSliderLabelShadowOptions, SliderLabel as FoundationSliderLabel, } from '@genesislcap/foundation-ui';
import { zeroSliderLabelStyles as styles } from './slider-label.styles';
import { zeroSliderLabelTemplate as template } from './slider-label.template';
/**
 * @tagname %%prefix%%-slider-label
 */
export class SliderLabel extends FoundationSliderLabel {
}
export const zeroSliderLabel = SliderLabel.compose(Object.assign({ baseName: 'slider-label', template,
    styles, shadowOptions: foundationSliderLabelShadowOptions }, defaultSliderLabelConfig));
